export const ADD_AGENT_STATUS = 'ADD_AGENT_STATUS'
export const SET_AGENT = 'SET_AGENT'
export const SET_AGENT_SIGN_IN = 'SET_AGENT_SIGN_IN'
export const SET_AGENT_SIGN_OUT = 'SET_AGENT_SIGN_OUT'
export const SET_AGENT_STATUS = 'SET_AGENT_STATUS'
export const UPDATE_AGENT_STATUS_TIME = 'UPDATE_AGENT_STATUS_TIME'
export const REMOVE_AGENT_STATUS = 'REMOVE_AGENT_STATUS'
export const RESET_AGENT = 'RESET_AGENT'
